import cx from 'classnames';
import styles from './ConfiguratorFilterLayout.module.scss';

export const ConfiguratorFilterLayout = ({ className, ...rest }) => {
  return <div className={cx(styles.root, className)} {...rest}></div>;
};
